import { useState } from "react";
import { useSocket } from "../context/SocketContext";
import { useAuth } from "../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import profile from "../assets/logo-nanthiat.png";
import Settings from "../settings/Settings";
import Loader from "./Loader";
import Browser from "../components/ui/Browser";
import Profile from "../components/ui/Profile";
import {
  BellIcon,
  ChevronDownIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export default function Navbar({ isSidebarOpen, setIsSidebarOpen }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { notifications, setNotifications } = useSocket();

  const [loading, setLoading] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleNavigation = (path) => {
    if (window.location.pathname === path) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(path);
    }, 8000);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <header className="w-full bg-white shadow-sm z-[1000]">
          <div className="flex justify-between items-center px-4 py-2">
            {/* 🔹 Gauche - Menu + Search */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className="p-2 rounded-md hover:bg-gray-100 transition"
              >
                <Bars3Icon className="w-6 h-6 text-gray-700" />
              </button>

              {/* 🔍 Search / Browser */}
              <div className="hidden sm:block">
                <Browser />
              </div>
            </div>

            {/* 🔹 Droite - Notifications, Settings, Profile */}
            <div className="flex items-center gap-4">

              {/* 🔔 Notifications */}
              <div className="relative">
                <button
                  onClick={() => setNotifOpen(!notifOpen)}
                  className="relative p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <BellIcon className="w-6 h-6 text-gray-700" />
                  {notifications.length > 0 && (
                    <span className="absolute top-0 right-0 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                      {notifications.length}
                    </span>
                  )}
                </button>

                {/* 🔻 Notifications dropdown */}
                {notifOpen && (
                  <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg z-[999] p-4">
                    <div className="flex justify-between items-center border-b pb-2">
                      <h3 className="font-semibold text-gray-800">Notifications</h3>
                      <button
                        onClick={() => setNotifications([])}
                        className="text-sm text-red-500 hover:underline"
                      >
                        Effacer tout
                      </button>
                    </div>
                    <div className="max-h-40 overflow-y-auto mt-2">
                      {notifications.length > 0 ? (
                        notifications.map((notif, idx) => (
                          <p
                            key={idx}
                            className="text-sm text-gray-600 border-b py-1"
                          >
                            {notif}
                          </p>
                        ))
                      ) : (
                        <p className="text-sm text-gray-400">Aucune notification</p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* ⚙️ Settings */}
              <Settings />

              {/* 👤 Profil utilisateur */}
              <div className="relative">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="flex items-center gap-2 bg-gray-100 px-2 py-1 rounded-full transition hover:shadow-md"
                >
                  <img
                    src={user?.profileImage || profile}
                    alt="profile"
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <div className="hidden md:block text-left">
                    <p className="text-sm font-semibold text-gray-800">
                      {user?.Nom || "Chargement..."}
                    </p>
                    <p className="text-xs text-gray-500">{user?.Rôle}</p>
                  </div>
                  <ChevronDownIcon className="w-4 h-4 text-gray-700" />
                </button>

                {/* 🔻 Menu utilisateur */}
                {menuOpen && (
                  <div className="absolute right-0 mt-2 w-60 bg-white rounded-lg shadow-lg z-50 p-4">
                    <div className="absolute top-2 right-2">
                      <button onClick={() => setMenuOpen(false)}>
                        <XMarkIcon className="w-5 h-5 text-gray-400 hover:text-gray-600" />
                      </button>
                    </div>
                    <Profile user={user} onLogout={handleLogout} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>
      )}
    </>
  );
}
